import DelBox from '../comps/DelBox';
import AddDepart from '../models/AddDepart';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import AddService from '../models/AddService';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import ServiceGroups from './ServiceGroups'; // ← NEW

const Services = () => {
    // ===== NEW: tab state =====
    const [activeTab, setActiveTab] = useState('services'); // 'services' | 'groups'

    const [toggleStates, setToggleStates] = useState({});
    const [loadingToggles, setLoadingToggles] = useState({});

    const initToggleStatesFromRecords = (records) => {
        const map = {};
        (records || []).forEach(r => {
            map[r.cat_id] = r.is_default === 1 || r.is_default === "1" || r.cat_default === 1 || r.cat_default === "1";
        });
        setToggleStates(map);
    };

    const handleToggle = async (id) => {
        if (!id) return;
        if (loadingToggles[id]) return;

        const prev = !!toggleStates[id];
        setToggleStates((s) => ({ ...s, [id]: !prev }));
        setLoadingToggles((l) => ({ ...l, [id]: true }));

        try {
            const fd = new FormData();
            fd.append('cat_id', id + "");
            fd.append('is_default', (!prev ? 1 : 0) + "");

            const resp = await axios.post(AppConst.BASE_URL + AppConst.updateCatDefaultUrl, fd, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            if (!resp || !resp.data || resp.data.status !== true) {
                throw new Error((resp && resp.data && (resp.data.message || resp.data.success)) || "Failed to update");
            }
            toast.success("Updated");
        } catch (err) {
            console.error("Toggle update failed", err);
            setToggleStates((s) => ({ ...s, [id]: prev }));
            toast.error("Failed to update default flag");
        } finally {
            setLoadingToggles((l) => {
                const copy = { ...l };
                delete copy[id];
                return copy;
            });
        }
    };

    const [formData, setFormData] = useState({
        l1: [],
        cat_type: 'service',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });
    const [isAdmin, setIsAdmin] = useState('');
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        if (roleId === 1 || roleId === "1") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }
        if (storedData) {
            const fd = new FormData();
            fd.append('cat_type', formData.cat_type + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                if (response.data.status) {
                    const records = response.data.records;
                    if (records) {
                        setFormData(prev => ({ ...prev, l1: records }));
                        initToggleStatesFromRecords(records);
                    } else {
                        setFormData(prev => ({ ...prev, l1: [] }));
                        setToggleStates({});
                    }
                }
            } catch (error) { }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const delItem = async (editItem) => {
        const fd = new FormData();
        fd.append('cat_id', editItem.cat_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delCatUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.status) {
                initData();
                toast.success('Delete Successfully');
            }
        } catch (error) { }
    };

    const handleAddDepart = () => {
        formData.page_no = 0;
        initData();
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }
        return () => { };
    }, []);

    const filteredList = formData.search_key.trim() === ""
        ? formData.l1
        : formData.l1.filter(item =>
            item.cat_name?.toLowerCase().includes(formData.search_key.toLowerCase())
        );

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#f1f5fb', color: '#405189',
                fontSize: '15px', fontWeight: '700',
                paddingLeft: '14px', paddingRight: '14px',
            }
        },
        rows: { style: { fontSize: '16px', minHeight: '58px' } },
        cells: { style: { paddingLeft: '14px', paddingRight: '14px', fontSize: '15px', lineHeight: '20px' } },
    };

    const columns = [
        { name: 'SN', selector: (row) => filteredList.indexOf(row) + 1, width: '70px', sortable: false },
        { name: 'Service Name', selector: (row) => row.cat_name, sortable: true, wrap: true },
        { name: 'Price', selector: (row) => row.cat_type1, sortable: true, width: '110px' },
        {
            name: 'Default',
            cell: (row) => (
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={!!toggleStates[row.cat_id]}
                        onChange={() => handleToggle(row.cat_id)}
                        disabled={!!loadingToggles[row.cat_id] || !isAdmin}
                    />
                    <span className="slider round"></span>
                </label>
            ),
            ignoreRowClick: true, allowOverflow: true, width: '110px',
        },
        { name: 'Description', selector: (row) => row.cat_type2, sortable: false, wrap: true },
        {
            name: 'Action',
            cell: (row) => (
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-sm btn-outline-primary"
                        disabled={!isAdmin}
                        style={{ opacity: !isAdmin ? 0.5 : 1 }}
                        onClick={() => {
                            setEditItem(row);
                            document.getElementById('addbt453').click();
                        }}
                    >
                        <i className="ri-pencil-fill fs-16 me-1"></i> Edit
                    </button>
                    <button
                        className="btn btn-sm btn-outline-danger"
                        disabled={!isAdmin}
                        style={{ opacity: !isAdmin ? 0.5 : 1 }}
                        onClick={() => delItem(row)}
                    >
                        <i className="ri-delete-bin-5-fill fs-16 me-1"></i> Delete
                    </button>
                </div>
            ),
            ignoreRowClick: true, allowOverflow: true, width: '220px',
        },
    ];

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">
                                            <i className="ri-list-settings-line me-2"></i>Services
                                        </h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        {activeTab === 'services' && (
                                            <div className="d-flex gap-1 flex-wrap">
                                                <button
                                                    id="addbt453"
                                                    style={{ display: "none" }}
                                                    type="button"
                                                    className="btn btn-success add-btn"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#showModal"
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-success add-btn"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setEditItem(null);
                                                        document.getElementById("addbt453").click();
                                                    }}
                                                >
                                                    <i className="ri-add-line align-bottom me-1"></i> Add Service
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* TABS */}
                            <div className="card-body pb-0">
                                <ul className="nav nav-tabs" role="tablist">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'services' ? 'active fw-bold' : ''}`}
                                            onClick={() => setActiveTab('services')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <i className="ri-list-check-2 me-1"></i> Services
                                            {activeTab === 'services' && (
                                                <span className="badge bg-primary ms-2">{filteredList.length}</span>
                                            )}
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'groups' ? 'active fw-bold' : ''}`}
                                            onClick={() => setActiveTab('groups')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <i className="ri-folder-2-line me-1"></i> Groups
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            {/* ========== TAB 1: SERVICES ========== */}
                            {activeTab === 'services' && (
                                <>
                                    <div className="card-body border border-dashed border-end-0 border-start-0">
                                        <form>
                                            <div className="row g-3">
                                                <div className="col-xxl-5 col-sm-6">
                                                    <div className="search-box">
                                                        <input
                                                            className="form-control search"
                                                            name="search_key"
                                                            onChange={handleChange}
                                                            value={formData.search_key}
                                                            placeholder="Search by name"
                                                            type="text"
                                                        />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="card-body pt-3">
                                        <div className="table-responsive table-card mb-1">
                                            <DataTable
                                                columns={columns}
                                                data={filteredList}
                                                pagination
                                                paginationPerPage={20}
                                                paginationRowsPerPageOptions={[5, 10, 20]}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Rows per page:',
                                                    rangeSeparatorText: 'of',
                                                    selectAllRowsItem: false,
                                                }}
                                                highlightOnHover
                                                responsive
                                                persistTableHead
                                                customStyles={customStyles}
                                                noHeader
                                            />
                                        </div>
                                        <AddService item={editItem} onAddDepart={handleAddDepart} />
                                        <DelBox />
                                    </div>
                                </>
                            )}

                            {/* ========== TAB 2: GROUPS ========== */}
                            {activeTab === 'groups' && (
                                <div className="card-body pt-3">
                                    <ServiceGroups isAdmin={isAdmin} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;